/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Stress_ModerateInputs */

const en_us2_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate`)
};

const pt_br2_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

const es_419_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const pt_pt2_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

const fr_fr2_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyen`)
};

const de_de2_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

const it_it2_workout_stress_moderate = /** @type {(inputs: Workout_Stress_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

/**
* | output |
* | --- |
* | "Moderate" |
*
* @param {Workout_Stress_ModerateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_stress_moderate = /** @type {((inputs?: Workout_Stress_ModerateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Stress_ModerateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_stress_moderate(inputs)
	if (locale === "es-419") return es_419_workout_stress_moderate(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_stress_moderate(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_stress_moderate(inputs)
	if (locale === "de-DE") return de_de2_workout_stress_moderate(inputs)
	if (locale === "it-IT") return it_it2_workout_stress_moderate(inputs)
	return en_us2_workout_stress_moderate(inputs)
});
export { workout_stress_moderate as "workout.stress_moderate" }